import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import ErrorBoundary from '@reverbdotcom/commons/src/components/error_boundary';

import {
  ITEM_SHOW_ROUTE_PATH,
  ITEM_PREVIEW_PATH,
  ITEM_PREVIEW_CONFIRM_PATH,
} from '../components/shared/constants';

const lazyItemShow = async () => {
  const Item2Layout = (await import(
    /* webpackChunkName: 'item-show' */
    '../components/item2_layout'
  )).default;

  return {
    Component: function ItemShowPage() {
      return (
        <ErrorBoundary>
          <Item2Layout />
        </ErrorBoundary>
      );
    },
  };
};

export const ItemShowRoute = (
  <Route
    key={ITEM_SHOW_ROUTE_PATH}
    path={ITEM_SHOW_ROUTE_PATH}
    handle={{ clientSide: false }}
    lazy={lazyItemShow}
  />
);

export const ItemPreviewRoute = (
  <Route
    key={ITEM_PREVIEW_PATH}
    path={ITEM_PREVIEW_PATH}
    lazy={lazyItemShow}
  />
);

export const ItemPreviewConfirmRoute = (
  <Route
    key={ITEM_PREVIEW_CONFIRM_PATH}
    path={ITEM_PREVIEW_CONFIRM_PATH}
    lazy={lazyItemShow}
  />
);
